import { Routes } from '@angular/router';
export const CONTENT_ROUTES: Routes = [
  // {
  //   path: 'admin',
  //   loadChildren: () => import('../../modules/admin/admin.module').then(x => x.AdminModule)

  // },
  {
    path: '',
    loadChildren: () => import('../../modules/public/public.module').then(x => x.PublicModule),
  }

];